module.exports = __webpack_public_path__ + "static/media/officernd.ceca9912.svg";